import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, map, mergeMap, of, switchMap } from 'rxjs';
import * as FieldActivityActions from '../_actions/fieldActivity';
import { FieldActivityDeprecatedService, FieldActivityService } from '../_services';

@Injectable({
  providedIn: 'root',
})
export class FieldActivityEffects {
  loadFieldActivities$ = createEffect(() =>
    this.actions$.pipe(
      ofType(FieldActivityActions.loadFieldActivities),
      switchMap(({ selectedYear }) =>
        this.fieldActivityDeprecatedService.getFieldActivities(selectedYear ?? null).pipe(
          map((fieldActivities) =>
            FieldActivityActions.loadFieldActivitiesSuccess({ fieldActivities })
          ),
          catchError((error) => of(FieldActivityActions.loadFieldActivitiesFailure({ error })))
        )
      )
    )
  );

  addFieldActivity$ = createEffect(() =>
    this.actions$.pipe(
      ofType(FieldActivityActions.addFieldActivity),
      mergeMap(({ fieldActivity }) =>
        this.fieldActivityService.saveFieldActivity(fieldActivity).pipe(
          map((savedFieldActivity) =>
            FieldActivityActions.addFieldActivitySuccess({ fieldActivity: savedFieldActivity })
          ),
          catchError((error) => of(FieldActivityActions.addFieldActivityFailure({ error })))
        )
      )
    )
  );

  updateFieldActivity$ = createEffect(() =>
    this.actions$.pipe(
      ofType(FieldActivityActions.updateFieldActivity),
      mergeMap(({ fieldActivity }) =>
        this.fieldActivityService.saveFieldActivity(fieldActivity).pipe(
          map((updatedFieldActivity) =>
            FieldActivityActions.updateFieldActivitySuccess({ fieldActivity: updatedFieldActivity })
          ),
          catchError((error) => of(FieldActivityActions.updateFieldActivityFailure({ error })))
        )
      )
    )
  );

  deleteFieldActivity$ = createEffect(() =>
    this.actions$.pipe(
      ofType(FieldActivityActions.deleteFieldActivity),
      mergeMap(({ id }) =>
        this.fieldActivityService.deleteFieldActivityById(id).pipe(
          map(() => FieldActivityActions.deleteFieldActivitySuccess({ id })),
          catchError((error) => of(FieldActivityActions.deleteFieldActivityFailure({ error })))
        )
      )
    )
  );

  getFieldActivity$ = createEffect(() =>
    this.actions$.pipe(
      ofType(FieldActivityActions.getFieldActivity),
      mergeMap(({ id }) =>
        this.fieldActivityService.getFieldActivityById(id).pipe(
          map((fieldActivity) => FieldActivityActions.getFieldActivitySuccess({ fieldActivity })),
          catchError((error) => of(FieldActivityActions.getFieldActivityFailure({ error })))
        )
      )
    )
  );

  constructor(
    private actions$: Actions,
    private fieldActivityDeprecatedService: FieldActivityDeprecatedService,
    private fieldActivityService: FieldActivityService
  ) {}
}
